// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d3c95715","453":"d6a26287"}[chunkId] + ".chunk.js";
};